import { listSilobagsService } from '@siloreal:shared:api/service/silobag/silobag-list';
import { getHeaderReportDefinition, type HeaderReportKind } from '../extra/header-report-config';
import { useLabTemplateDownload } from './use-lab-template-download';
import { useQualitySampleUpload } from './use-quality-sample-upload';

export function useHeaderQualitySampleActions() {
  const upload = useQualitySampleUpload();
  const download = useLabTemplateDownload();

  const openTemplates = (kind: HeaderReportKind): void => {
    void download.open(async () => {
      const definition = getHeaderReportDefinition(kind);
      const response = await listSilobagsService({
        filter: definition.filters,
        onlyIds: true,
      });

      return response.ids;
    });
  };

  return {
    upload,
    download,
    openCombinedTemplates: () => openTemplates('combined'),
    openSilosProTemplates: () => openTemplates('silospro'),
    openSilobagTemplates: () => openTemplates('silobag'),
  };
}
